import ProceduresService from "../office/proceduresService";

class ProcedureHandler {
  static async searchByQuery(query) {
    try {
      const data = await ProceduresService.searchByQuery( query );
      return data?.data?.Search ?? [];
    } catch (error) {
      console.error("Error in getUserByName use case:", error);
      return [];
    }
  }
}

export default ProcedureHandler;